import { SKIPPED } from '../../tools/abstractHooks';
export function startTelemetrySessionContext(hooks, sessionManager, extraContext) {
    hooks.register(1 /* HookNames.AssembleTelemetry */, ({ startTime }) => {
        const session = sessionManager.findTrackedSession(startTime);
        if (!session) {
            return SKIPPED;
        }
        return {
            session: {
                id: session.id,
            },
            anonymous_id: session.anonymousId,
            ...extraContext,
        };
    });
}
//# sourceMappingURL=telemetrySessionContext.js.map